var collapsible_list_component_rtlignore_default = {
  "ltr": "dF-62",
  "rtl": "-THL4",
  "iconContainer": "XA0YV",
  "icon": "EOea6",
  "isExpanded": "Rf37s",
  "listDimensions": "_8P356"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
